<template>
  <dropdown-input
    :options="dropdownOptions"
    theme="primary"
    position="left"
    @select="handleDropdownSelect"
  >
    <button-input>
      <span class="switch__current">{{ currentLocale }}</span>
      <font-awesome-icon icon="angle-down" />
    </button-input>
  </dropdown-input>
</template>

<script>
import FormMixin from '@/mixins/forms/Form'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'LocaleSwitch',

  mixins: [FormMixin],

  components: {
    FontAwesomeIcon
  },

  computed: {
    currentLocale () {
      return this.$locale.current()
    },
    dropdownOptions () {
      let options = []
      const availableLocales = this.$locale.available()

      availableLocales.map(locale => {
        options.push({
          label: this.$t(`localeSwitch.${locale}`),
          value: locale
        })
      })
      return options
    }
  },

  methods: {
   handleDropdownSelect ({ value }) {
      switch (value) {
        default:
          this.$locale.change(value)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app/LocaleSwitch.vue